export enum WIDGET_LINKS {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=501884723
     * */
    ADD_LINK = 'LUMX.LINK_DIALOG_ADD_TITLE',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13454446
     */
    ADD_TARGET_BLANK = 'WIDGET_TYPE_LINKS_ADD_TARGET_BLANK',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13454454
     */
    DIALOG_TITLE = 'WIDGET_TYPE_LINKS_MODAL',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13454457
     */
    LINKS_THUMBNAIL_UPLOAD = 'WIDGET_TYPE_LINKS_THUMBNAIL_UPLOAD',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=771037016
     */
    LINKS_WIDGET_SETTINGS_TITLE = 'DESIGNER.LINKS_WIDGET_SETTINGS_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=770365019
     */
    WRITER_MODE_EMPTY_STATE_TITLE = 'WIDGET_LINKS_SETTINGS.NO_LINKS_TITLE',
}
